<template>
    <div :id="id" class="custom-drop">
        <div :class="['custom-drop-wrapper',additional_classes]" @click="openDrop">
            <div class="custom-drop-chosen" >
                <span>{{getSelectName}}</span>
                <div v-if="custom_icon" class="custom-drop-icon"></div>
                <svg class="d-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                    <path d="M1 1L7 7L13 1" stroke="#3326AE" stroke-width="2" stroke-miterlimit="20"/>
                </svg>            
            </div>
        </div>
        <div :style="height != undefined ? `height:${height}`:''" :class="['custom-drop-item-list']">
            <div v-for="(i, key) in drop_items" :key="key" @click="selectItem(i)" :class="['custom-drop-item', selected_items.includes(i.id) ? 'active' : '']">
                <span>{{i.naziv}}</span>
                <!-- <div class="svg-spin-wrapper-spis" style="width: 50.95px;justify-content: center;">
                    <svg class="update-event-spin spinner-spis" id="add-to-spis" style="display: none"
                        viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                    </svg>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    props:['id', 'drop_items', 'init_text','additional_classes', 'custom_icon',"height", 'selected_items'],
    data() {
        return {
        }
    },
    model:{
        prop: 'selected_items',
        event: 'click'
    },
    computed:{
        getSelectName(){
            let ret_val='';

            if(this.selected_items.length == 0) ret_val = this.drop_items[0].naziv;
            else if(this.selected_items.length == 1) ret_val = this.drop_items.find(i=>i.id == this.selected_items[0]).naziv;
            else{
                this.drop_items.map(it=> {if(this.selected_items.includes(it.id)) ret_val+=`${it.multiselect_val}, `})
            }
            return ret_val.slice(0,80);
        }
    },
    methods:{
        openDrop(){
            $(`#${this.id}`).toggleClass('active')
            if ($(`#${this.id} .custom-drop-item.active`).length != 0) {
                $(`#${this.id} .custom-drop-item.active`)[0].scrollIntoView({block:'center'});
            }
        },
        selectItem(item){
            if (this.selected_items.includes(item.id)) {
                let new_selected_items = this.selected_items.filter(i=>i != item.id)
                this.$emit('update:selected_items', new_selected_items)
            }
            else{
                if (item.id != null) {
                    this.selected_items.push(item.id)
                }
            }
        }
    },
    mounted() {
        setTimeout(() => {
            let _this = this;
            $('.v-application--wrap,.tarife-unos').click(function (e) {
                var container = $(`#${_this.id}`)
                if(!container.is(e.target) && container.has(e.target).length === 0) {
                    $(`#${_this.id}`).removeClass('active')
                }
            });
        }, 1000);
    },
    beforeDestroy() {
        $('.v-application--wrap,.tarife-unos').off();
    },
}
</script>